import { Type } from "class-transformer";
import type { EntityValidationRules } from "../services/validationService";

export default class BulkExemption {
  officialRecordId: string;
  @Type(() => Date)
  excelFile?: File;
  reason?: string;
  exemptionReasonId?: string;
}

export const BulkExemptionValidationRules: EntityValidationRules<BulkExemption> = {
  officialRecordId: {
    required: true,
    isLength: {
      min: 3,
      max: 50,
    },
  },
  excelFile: {
    required: "fileRequired",
    isFileType: {
      type: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", ""], // On Windows without Office mime type is empty string %)
      customMessage: "excel",
    },
  },
};
